module.exports = __webpack_public_path__ + "img/s1-4-ja.027b03c9.jpg";